'use client';

import React from 'react';
import { Box, Accordion } from '@kohler-dsm-library/kohler-core';
import FeaturedProduct from '../FeaturedProduct';
import styles from './FeaturedProductAccordion.module.css';

const FeaturedProductAccordion = (data) => {
  const items = data?.featuredProductAccordionItems || [];
  return (
    <Box className={styles.accordionGroup}>
      {items.map((item, index) => (
        <Accordion key={index} title={{ text: item.accordiontitle }} divider={true} size="medium">
          <div className={styles.accordionContent}>
            <FeaturedProduct data={item} />
          </div>
        </Accordion>
      ))}
    </Box>
  );
};

export default FeaturedProductAccordion;
